import { app } from "./main-app"
import PrimeVue from "primevue/config"

app.use(PrimeVue, { ripple: false, inputStyle: "outlined" })
